/**
 * Categories tabs (shared by Categories All page + Categories Drawer).
 * Scopes layout + click handlers to a single root so multiple instances
 * (page + drawer) do not conflict.
 */
(function () {
  function layoutTabs(root) {
    if (!root || root.dataset.categoriesTabsLaidOut === "true") return;

    var tabsWrapper = document.createElement("div");
    tabsWrapper.className = "main_gp_tabs";

    var contentWrapper = document.createElement("div");
    contentWrapper.className = "main_gp_content";

    Array.from(root.children).forEach(function (el) {
      if (el.classList.contains("main_gp_tab_item")) {
        tabsWrapper.appendChild(el);
      } else if (el.classList.contains("main_gp_tab_content")) {
        contentWrapper.appendChild(el);
      }
    });

    root.innerHTML = "";
    root.appendChild(tabsWrapper);
    root.appendChild(contentWrapper);
    root.dataset.categoriesTabsLaidOut = "true";
  }

  function bindTabs(root) {
    if (!root || root.dataset.categoriesTabsBound === "true") return;

    var tabs = root.querySelectorAll(".main_gp_tab_item");
    var contents = root.querySelectorAll(".main_gp_tab_content");

    tabs.forEach(function (tab, index) {
      tab.setAttribute("data-tab", String(index));
    });
    contents.forEach(function (content, index) {
      content.setAttribute("data-tab", String(index));
    });

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var id = tab.getAttribute("data-tab");
        tabs.forEach(function (t) {
          t.classList.remove("active");
        });
        contents.forEach(function (c) {
          c.classList.remove("active");
        });
        tab.classList.add("active");
        var panel = root.querySelector(
          '.main_gp_tab_content[data-tab="' + id + '"]'
        );
        if (panel) panel.classList.add("active");
      });
    });

    if (tabs.length) tabs[0].click();
    root.dataset.categoriesTabsBound = "true";
  }

  function init(root) {
    if (!root) return;
    layoutTabs(root);
    bindTabs(root);
  }

  function initAll(selector) {
    document
      .querySelectorAll(selector || "[data-categories-tabs-root]")
      .forEach(init);
  }

  window.HdtCategoriesTabs = {
    init: init,
    initAll: initAll,
  };

  document.addEventListener("DOMContentLoaded", function () {
    initAll();
  });
})();
